import { HiOutlineCloud } from "react-icons/hi";
import { AiOutlineLineChart } from "react-icons/ai";
import { Col, Container, Row } from "reactstrap";
import images from "../../assets/images";
import { useSelector } from "react-redux";
import { getLocalization } from "../../redux/localization";

const FirstSection = () => {
  const t = useSelector(getLocalization);
  return (
    <section className="adSection1">
      <Container>
        <Row>
          <Col md={5}>
            <h2>{t.getString("Access from anywhere")}</h2>
            <h3>{t.getString("Rental Manangement System")}</h3>
            <p>
              {t.getString(
                "It is an advanced software that can work in interaction with the mobil application prepared using the latest technologies"
              )}
            </p>
            <div className="sectionCard sectionCard1">
              <HiOutlineCloud color="#05ddff" size={60} />
              <div>
                <h4>{t.getString("CLOUD BASED SYSTEM")}</h4>
                <p>
                  {t.getString(
                    "We run systems integrated with multiple platforms"
                  )}
                </p>
              </div>
            </div>
            <div className="sectionCard sectionCard2">
              <AiOutlineLineChart color="#1edc6a" size={80} />
              <div>
                <h4>{t.getString("HIGH LEVEL INTERACTION")}</h4>
                <p>
                  {t.getString(
                    "Rentificial system is an advanced rental management software that can work in interaction with the mobile application"
                  )}
                </p>
              </div>
            </div>
          </Col>
          <img
            src={images.addashboard1}
            alt="Dashboard"
            className="Dashboard"
          />
        </Row>
      </Container>
    </section>
  );
};
export default FirstSection;
